import toString from 'lodash/toString';
import { isArray, isBoolean, isNumber, isObject, isString } from '@direct-frontend/stdlib';
import { protect } from '../../function';

/*
 * В @direct-frontend/modules-request есть встроенная сериализация.
 * Для примитивных query-параметров используй встроенное поле params.
 *
 * Используй этот хелпер, если важны следующие отличия:
 * 1) Среди параметров есть массивы.
 *      - Поведение библиотеки: statuses:["FOO", "BAR"] -> ?statuses=FOO,BAR
 *      - Поведение хелпера:                        ... -> ?statuses=FOO&statuses=BAR
 * 2) Среди параметров есть объекты.
 *      - Поведение библиотеки (результат toString): status:{hello:123} -> ?status=[object Object]
 *      - Поведение хелпера (сериализует в строку JSON):            ... -> ?status={"hello":123}
 */
export function encodeSearchParams(record: Record<string, unknown>) {
    const urlSearchParams = new URLSearchParams();

    Object.entries(record).forEach(([key, value]) => {
        if (isString(value)) {
            urlSearchParams.set(key, value);
        } else if ((isNumber(value) || isBoolean(value)) && !Number.isNaN(value)) {
            urlSearchParams.set(key, toString(value));
        } else if (isArray(value)) {
            value.forEach((item) => urlSearchParams.append(key, toString(item)));
        } else if (value && isObject(value)) {
            protect(() => {
                urlSearchParams.set(key, JSON.stringify(value));
            });
        }
    });

    const str = urlSearchParams.toString();

    return str ? `?${str}` : '';
}
